import axios from '../httpHandler';

export const getSomething = async (organizationId) => {
  try {
    const result = await axios.get(`user/auth/token`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const loginUser = async (data) => {
    return axios.post(`user/auth/token`, {
        ...data,
    });
};

export const forgotPassword = async (data) => {
  return axios.post(`user/password/forget`, {
      ...data,
  });
};

export const changePassword = async (data) => {
  return axios.post(`user/password/change`, {
      ...data,
  });
};

